import React, { Component } from 'react'
import { TableComp } from 'sz-react-utils-lite'
import { connect } from 'react-redux'
import { ApproveDirectDepositFxn, getAllEvents } from '../actions/index'
import {

  DefaultTablePagination, displayDate
} from '../../../components/_utils/appUtils'
import { ColumnWidth } from '../../WebComponent/columnWidth'
import { Icon, Tooltip } from 'antd'
import AddEventXTravelWorld from './addEventDrawer'
import AddMeetingXTravelDrawer from './addMeetingDrawer'

class XTravelWorldEventList extends Component {

  events = {
    showAddEventDrawer: (eventId, pageName) => {
      this.setState({
        visibleEventDrawer: true,
        eventId: eventId,
        pageName: pageName
      })
    },
    hideAddEventDrawer: () => {
      this.setState({
        visibleEventDrawer: false,
        eventId: '',
        pageName: ''
      })
    },
    showAddMeetingDrawer: (eventId) => {
      this.setState({
        visibleDepositDrawer: true,
        eventId: eventId
      })
    },
    hideAddMeetingDrawer: () => {
      this.setState({
        visibleDepositDrawer: false,
        eventId: ''
      })
    },
    reload: () => {
      this.tableRef.current.reload()
    },
    approveDeposit: async (depositData) => {
      let { dispatch } = this.props
      let resp = await dispatch(ApproveDirectDepositFxn(depositData))
      if (resp && resp.success) {
        if (this.tableRef && this.tableRef.current) {
          this.tableRef.current.reload()
        }
      }
    }
  }

  constructor(props) {
    super(props)
    this.state = {
      visibleDepositDrawer: false
    }
    this.tableRef = React.createRef()
  }

  componentDidMount() {
    //use effect
  }

  apiRequest = (params) => {
    let { dispatch } = this.props
    return new Promise(async (resolve) => {
      let { data } = await dispatch(getAllEvents({
        ...params
      }))
      resolve(data)
    })
  }


  render() {
    const columns = [
      {
        title: '#',
        key: '_id',
        dataIndex: '_id',
        width: 50,
        render: (ite, record, index) => {
          return (
            <React.Fragment>
              {index + 1}
            </React.Fragment>
          )
        }
      },
      {
        title: 'Name',
        key: 'name',
        dataIndex: 'name',
        width: 200,
        render: (item) => {
          return (
            <ColumnWidth width={200}>
              {item}
            </ColumnWidth>
          )
        }
      },
      {
        title: 'Start Date',
        key: 'startDate',
        dataIndex: 'startDate',
        width: 150,
        render: (item) => {
          return (
            <ColumnWidth width={150}>
              {displayDate(item)}
            </ColumnWidth>
          )
        }
      },
      {
        title: 'End Date',
        key: 'endDate',
        dataIndex: 'endDate',
        width: 150,
        render: (item) => {
          return (
            <ColumnWidth width={150}>
              {displayDate(item)}
            </ColumnWidth>
          )
        }
      },
      {
        title: 'Country',
        key: 'countryId',
        dataIndex: 'countryId',
        width: 200,
        render: (item) => {
          return (
            <ColumnWidth width={200}>
              {item && item.countryName && item.countryName}
            </ColumnWidth>
          )
        }
      },
      {
        title: 'Venue',
        key: 'venue',
        dataIndex: 'venue',
        searchTextName: 'venue',
        width: 200,
        render: (item) => {
          return (
            <ColumnWidth width={150}>
              {item}
            </ColumnWidth>
          )
        }
      },
      {
        title: 'Address',
        key: 'address',
        dataIndex: 'address',
        width: 200,
        render: (item) => {
          return (
            <ColumnWidth width={300}>
              {item}
            </ColumnWidth>
          )
        }
      },
      {
        title: 'Actions',
        key: 'details',
        dataIndex: 'details',
        width: 200,
        render: (item, record) => {
          return (
            <ColumnWidth width={200}>
              <Tooltip title={'Update Event'}>
                <Icon
                  className={'btn btn-default'}
                  type={'edit'}
                  onClick={() => {
                    this.events.showAddEventDrawer(record._id, 'Update')
                  }}
                />
              </Tooltip>
              <Tooltip title={'Add Meeting'}>
                <Icon
                  className={'btn btn-default ml10'}
                  type={'plus'}
                  onClick={() => {
                    this.events.showAddMeetingDrawer(record._id)
                  }}
                />
              </Tooltip>

            </ColumnWidth>
          )
        }
      }
    ]
    return (
      <div className='row  mt-4'>
        <div className='col-lg-12'>
          <div className='card'>
            <div className='table-head d-flex align-items-center'>
              <h5>XTravelWorld Event List</h5>
              <div className='search-box-table'>
              </div>
              <div className='sort-box-table mark-btn'>
                <div>
                  <a className='btn' onClick={() => {
                    this.events.showAddEventDrawer('', 'Add')
                  }}>
                    <img src={'../dist/icons/plus.png'} className={'plus'} /> Add Event
                  </a>
                </div>
              </div>
            </div>
            <div className='card-body table-responsive'>
              <TableComp columns={columns}
                         ref={this.tableRef}
                         pagination={DefaultTablePagination()}
                         apiRequest={this.apiRequest}
                         extraProps={{ scroll: { x: 1000 } }}
              />
            </div>
          </div>
          {this.state.visibleEventDrawer ?
            <AddEventXTravelWorld
              visible={this.state.visibleEventDrawer}
              eventId={this.state.eventId}
              pageName={this.state.pageName}
              onClose={() => {
                this.events.hideAddEventDrawer()
                this.events.reload()
              }}
              onSubmit={() => {
                this.events.hideAddEventDrawer()
                this.events.reload()
              }} /> : null}

          {this.state.visibleDepositDrawer ?
            <AddMeetingXTravelDrawer
              visible={this.state.visibleDepositDrawer}
              eventId={this.state.eventId}
              pageName={this.state.pageName}
              onClose={() => {
                this.events.hideAddMeetingDrawer()
                this.events.reload()
              }}
              onSubmit={() => {
                this.events.hideAddMeetingDrawer()
                this.events.reload()
              }} /> : null}
        </div>
      </div>
    )
  }
}


const mapStateToProps = ({ global }) => ({
  categories: global.categories,
  currentUser: global.currentUser

})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(XTravelWorldEventList)